// extracted by mini-css-extract-plugin
export default {"item":"index_item__BbdPY","row":"index_row__0Dy5o","icon":"index_icon__ItYtK","content":"index_content__J0ViX","label":"index_label__CCgd2"};